import { BsEye } from "react-icons/bs";
import React, { useState } from "react";
import {
  CardWrap,
  Header,
  Footer,
  ThreeDotsContainer,
  UpdateIcon,
} from "./style";
import cloc from "../../../assets/icons/clock.svg";
import calendar from "../../../assets/icons/calendar.svg";
import { FiMoreVertical } from "react-icons/fi";
import Detail from "../Detail";
import { BiArchiveOut } from "react-icons/bi";
import { useShowModal } from "../../../hooks";

function Message({ data, notFunc, onAchive, noaction }) {
  const [open, setOpen] = useState(false);
  const { showBlured } = useShowModal();
  const sectors = {
    1: "Ishlab-chiqarish",
    2: "Xizmat-ko'rsatish",
    3: "Tibbiyot",
    4: "Savdo-sotiq",
    5: "Ta'lim",
  };
  const hadleview = (data) => {
    if (data) {
      showBlured({
        title: "Batafsil",
        maxWidth: "500px",
        maxHeight: "600px",
        overflow: "auto",
        withHeader: false,
        body: () => <Detail data={data} />,
      });
    }
  };
  const handlesave = (id) => {
    if (!noaction) {
      onAchive(id);
    } else {
      alert("Ma'lumot arxivlangan");
    }
  };
  return (
    <div>
      <CardWrap>
        <Header>
          <div>
            <h2>{data?.title}</h2>
            <p>{data?.phone}</p>
          </div>
          <div className="header">
            {notFunc ? (
              <FiMoreVertical className="three-dots" />
            ) : (
              <FiMoreVertical
                className="three-dots"
                onClick={() => (open ? setOpen(false) : setOpen(true))}
              />
            )}
          </div>
          <>
            {open && (
              <ThreeDotsContainer
                onMouseOver={() => setOpen(true)}
                onMouseOut={() => setOpen(false)}
              >
                <UpdateIcon
                  onClick={() => handlesave(data?.id)}
                  disabled={noaction}
                >
                  <BiArchiveOut size={13} className="editicon" />
                  Arxivlash
                </UpdateIcon>
                <UpdateIcon onClick={() => hadleview(data)}>
                  <BsEye size={13} className="editicon" />
                  Batafsil
                </UpdateIcon>
              </ThreeDotsContainer>
            )}
          </>
        </Header>
        {data?.industry_sector && (
          <div className="sector">
            <div className="title">Faoliyat sohasi:</div>
            <div className="desc">{sectors[data.industry_sector]}</div>
          </div>
        )}
        <Footer>
          <div>
            <div className="date-title">Bog‘lanish sanasi</div>
            <div className="date">
              <img src={calendar} alt="" /> {data?.date}
            </div>
          </div>
          <div>
            <div className="date-title">Bog‘lanish vaqti</div>
            <div className="date">
              <img src={cloc} alt="" />
              {data?.hour}
            </div>
          </div>
        </Footer>
      </CardWrap>
    </div>
  );
}

export default Message;
// #6610F2;
